import { EmailNotificationFilterTypes } from "@avenueops/frontend-shared";
import { ManualNotificationType } from "@avenueops/shared-types";
import { DropdownMultiSelect, SmartForm } from "@avenueops/web-components";
import CustomNotificationsAndSignals from "components/monitors/editFormReboot/CustomNotificationsAndSignals";
import CustomSubscriberSignalFormat from "components/monitors/editFormReboot/CustomSubscriberSignalFormat";
import { Controller, useFormContext, useWatch } from "react-hook-form";

interface Props {
  notificationPrefix: string;
  disableCustomize?: boolean;
}

export function EmailNotificationInput({ notificationPrefix, disableCustomize }: Props) {
  const { control, watch } = useFormContext();
  const notification: ManualNotificationType = useWatch({ name: notificationPrefix });
  const useCustomIntegration = watch(`${notificationPrefix}.useCustomIntegration`);

  return (
    <>
      <div className="col-span-4">
        {useCustomIntegration ? (
          <SmartForm.TextInput name={`${notificationPrefix}.emailFrom`} title="Email Address to Send From" placeholder="richard@piedpiper.com" />
        ) : null}

        <Controller
          control={control}
          name={`${notificationPrefix}.recipientValue`}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <DropdownMultiSelect
              title="Email Addresses to Notify"
              placeholder="richard@piedpiper.com"
              selectedValues={value ? value?.split(",") : []}
              onChange={(values) => {
                onChange(values?.join(","));
              }}
              options={[]}
              name={`${notificationPrefix}.recipientValue`}
              onCreate={(searchText: any) => {
                return { label: searchText, value: searchText };
              }}
              error={error}
            />
          )}
        />

        <div className="pt-5">
          <Controller
            control={control}
            name={`${notificationPrefix}.emailCCRecipient`}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <DropdownMultiSelect
                title="Email Addresses to CC"
                placeholder="richard@piedpiper.com"
                selectedValues={value ? value?.split(",") : []}
                onChange={(values) => {
                  onChange(values?.join(","));
                }}
                options={[]}
                name={`${notificationPrefix}.emailCCRecipient`}
                onCreate={(searchText: any) => {
                  return { label: searchText, value: searchText };
                }}
                error={error}
              />
            )}
          />
        </div>
      </div>
      {disableCustomize ? null : (
        <div className="col-span-6">
          <CustomNotificationsAndSignals
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            supportedTypes={EmailNotificationFilterTypes}
          />
        </div>
      )}
    </>
  );
}
